import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import AppRoutes from "./routes/Routes"; // Import the Routes file
import { ThemeProvider } from "@mui/material/styles";
import theme from "./assets/theme/light";
import Navbar from "./components/Landing/NavBar"; // Import the Navbar component
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";
import { auth } from "./services/firebase";
import { ChildProvider } from "./contexts/ChildContext";
import { RoleProvider } from "./contexts/RoleContext";
import { ErrorBoundary } from "./contexts/ErrorContext";
import "./services/messaging/setupTests";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";

const App = () => {
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // setUser(user);
      } else {
        // setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    if (process.env.NODE_ENV !== "production") {
      if (!("serviceWorker" in navigator)) {
        return undefined;
      }

      const cleanupKey = "captureez:dev-sw-cleaned";
      if (window.sessionStorage.getItem(cleanupKey) === "1") {
        return undefined;
      }

      window.sessionStorage.setItem(cleanupKey, "1");

      const cleanupDevServiceWorker = async () => {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((registration) => registration.unregister()));

          if ("caches" in window) {
            const cacheKeys = await caches.keys();
            await Promise.all(cacheKeys.map((cacheKey) => caches.delete(cacheKey)));
          }

          console.log("Removed stale development service workers and caches.");
        } catch (error) {
          console.error("Failed to clean up development service workers:", error);
        }
      };

      cleanupDevServiceWorker();
      return undefined;
    }

    const scheduleRegistration = () => {
      registerServiceWorker();
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(scheduleRegistration, { timeout: 3000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(scheduleRegistration, 1500);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <ChildProvider>
        <RoleProvider>
          <Router>
            <ErrorBoundary>
              <AnalyticsRouteTracker />
              <Navbar />
              <AppRoutes />
            </ErrorBoundary>
          </Router>
        </RoleProvider>
      </ChildProvider>
    </ThemeProvider>
  );
};

export default App;
